import React, { useEffect, useRef, useState } from 'react'

import { Icon, Table, Tooltip } from 'antd'
import get from 'lodash/get'

import {
  makePaginationItemRender,
  patchPaginationAria,
} from '../../../../../../../../../utils/pagination'

const AddMembersTab = props => {
  const clientMembers = get(props, 'clientMembers')
  const teamName = get(props, 'teamName')
  const handleAddMemberClick = get(props, 'handleAddMemberClick')
  const containerRef = useRef(null)
  const [page, setPage] = useState(1)

  useEffect(() => {
    patchPaginationAria(containerRef.current)
    const observer = new MutationObserver(() => patchPaginationAria(containerRef.current))
    if (containerRef.current)
      observer.observe(containerRef.current, { childList: true, subtree: true })
    return () => observer.disconnect()
  }, [])

  const columns = [
    {
      dataIndex: 'firstName',
      render: (text, { lastName }) => <div>{`${text} ${lastName}`}</div>,
      title: 'Name',
    },
    { dataIndex: 'email', title: 'Email' },
    {
      dataIndex: 'action',
      render: (text, record) => (
        <Tooltip title={`Add to ${teamName}`}>
          <button
            type="button"
            aria-label={`Add ${record.firstName} ${record.lastName} to ${teamName}`}
            onClick={() => handleAddMemberClick(record)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <Icon type="plus-circle" theme="twoTone" aria-hidden />
          </button>
        </Tooltip>
      ),
      title: '',
    },
  ]

  const pagination = {
    current: page,
    itemRender: makePaginationItemRender(page),
    onChange: setPage,
  }

  return (
    <div ref={containerRef}>
      <Table dataSource={clientMembers} columns={columns} pagination={pagination} />
    </div>
  )
}

export default AddMembersTab
